import { sanityLanguage } from '@/constants/language';
import { useGetTestimonialsBySlugQuery } from './generated';

// Always sync with https://gitlab.com/mallpay/frontend/cms/-/blob/main/schemas/testimonialsLists.ts
type Slug =
	| 'for-eshops'
	| 'homepage'
	| 'pay-in-three'
	| 'packages'
	| 'products'
	| 'career'
	| 'shop-wisely'
	| 'deferred-payment'
	| 'revolving-loan'
	| 'testimonials-facebook'
	| 'testimonials-app'
	| 'testimonials-google';

export type Testimonial = {
	name: string;
	text: string;
	job?: string | null;
	source?: string | null;
	link: string;
	ratingStars?: string | null;
	type: string | null;
	logo: string | null;
};

export async function getTestimonialsBySlug(slug: Slug): Promise<Testimonial[]> {
	const fetchAllTestimonials = useGetTestimonialsBySlugQuery.fetcher({
		slug,
		i18nLang: sanityLanguage,
	});

	const allTestimonials = await fetchAllTestimonials();

	if (
		!allTestimonials?.allTestimonialsLists ||
		!allTestimonials.allTestimonialsLists.length ||
		!allTestimonials.allTestimonialsLists[0].testimonials
	) {
		throw new Error('No testimonials found and there are expected to be some.');
	}

	return allTestimonials.allTestimonialsLists[0].testimonials.map((item) => ({
		name: item?.name || '',
		text: item?.text || '',
		type: item?.type || 'b2c',
		job: item?.job,
		source: item?.source,
		link: item?.link || '#',
		ratingStars: item?.ratingStars || '5',
		logo: item?.logo?.asset?.url || null,
	}));
}
